import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/closeDia.svg'


const _withScopeId = n => (_pushScopeId("data-v-de6dc078"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "bottomBtn"
}
const _hoisted_5 = { class: "btnText" }
const _hoisted_6 = { class: "btnText" }

import { computed, } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'noticeDialog',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Unbind Device",
  },
  width: {
    type: Number,
  },
  info: {
    type: String,
  },
  Cancel: {
    type: String,
    default: "pop.cancel",
  },
  Okay: {
    type: String,
    default: "Confirm",
  },
  showBtn: {
    type: Boolean,
    default: true,
  },
  showclose: {
    type: Boolean,
    default: false,
  },
  // 如果是解绑来使用该组件，则要给close事件单独处理
  // 解绑使用为true，其他使用为false
  user: {
    type: Boolean,
    default: false,
  },
  showHeader: {
    type: Boolean,
    default: true,
  }
},
  emits: ["cancle", "confirm", "unbindCancle"],
  setup(__props, { emit: __emit }) {

const props = __props
const store = useStore();
// const emit = defineEmits(["change"]);
const emit = __emit;
const visible = computed(() => props.visible);
const lang = computed(() => store.state.currentLang);
const handleClose = () => {
  if (props.user) {
    emit("unbindCancle", false);
  } else {
    emit("cancle", false);
  }
};

const clickClose = () => {
  emit("cancle", false);
};

const submit = () => {
  emit("confirm", false);
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(lang.value == 'ar' ? 'reverse' : '')
  }, [
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      width: __props.width,
      "show-close": __props.showclose,
      "close-on-click-modal": false
    }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(__props.info) + " ", 1),
          _renderSlot(_ctx.$slots, "img")
        ]),
        (__props.showBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                class: "cancelBtn diaBtn",
                onClick: clickClose
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(__props.Cancel)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                class: "saveBtn diaBtn",
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(__props.Okay)), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (__props.showHeader)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(__props.title)), 1),
              _createElementVNode("span", {
                onClick: handleClose,
                class: "close"
              }, _hoisted_2)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "width", "show-close"])
  ], 2))
}
}

})